import { Controller } from '@hotwired/stimulus';

// Toggles the checked state of cities on and off,
// and updates a hidden input field with the selected city IDs as JSON.
export default class extends Controller {
  static targets = ['checkbox', 'cityIdsJson']

  check (event) {
    this.setChecked(true, event.params.tag)
    this.updateCityIdsJson()
  }

  // Check all checkboxes
  checkAll () {
    this.setChecked(true)
    this.updateCityIdsJson()
  }

  // Set checked state for checkboxes depending on segment tag the city is a part of
  setChecked(checked, onlyWithTag) {
    this.checkboxTargets.forEach((checkbox) => {
      const rawTaggedValue = checkbox.dataset.cityBulkCheckerTaggedValue
      let taggedValues = []
      if (rawTaggedValue) {
        taggedValues = JSON.parse(rawTaggedValue)
      }
      if (!onlyWithTag || taggedValues.includes(onlyWithTag)) {
        checkbox.checked = checked
      }
    })

    this.updateCityIdsJson()
  }

  // Uncheck all checkboxes
  uncheckAll (event) {
    this.setChecked(false, event.params.tag)
    this.updateCityIdsJson()
  }

  // Update the hidden input field with the selected city IDs as JSON
  updateCityIdsJson () {
    const selected = this.checkboxTargets.filter(cb => cb.checked).map(cb => parseInt(cb.value))

    if (this.hasCityIdsJsonTarget) {
      this.cityIdsJsonTarget.value = JSON.stringify(selected)
    }
  }
}
